export const tokensConstants = {
  ACTION_GET_ALL_TOKENS: '@tokens/ACTION_GET_ALL_TOKENS',
  ACTION_LOCAL_ALL_TOKENS: '@tokens/ACTION_LOCAL_ALL_TOKENS',
};
